import { RepositoryFactory } from '../../RepositoryFactory';
const withdrawals = new RepositoryFactory('withdrawal');

export default {
  namespaced: true,
  state: {
    // Single user
    withdrawal: {},
    withdrawals: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
  },
  getters: {
    getWithdrawal(state) {
      return state.withdrawal;
    },
    getWithdrawals(state) {
      for (const iterator of state.withdrawals) {
        const date = new Date(iterator.createdAt);
        iterator.createdAt = date.toLocaleDateString('pt-BR');
      }

      return state.withdrawals.map(s => ({
        id: s.id,
        bank: s.bank,
        createdAt: s.createdAt,
        status: s.status,
        email: s.user.email,
      }));
    },
    getWithdrawalsTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
  },
  mutations: {
    SET_WITHDRAWAL(state, data) {
      state.withdrawal = data;
    },
    SET_WITHDRAWALS(state, data) {
      state.withdrawals = data.items;
      state.total = data.totalOfItems;
      state.itemCount = data.itemCount;
      state.totalPages = data.pageCount;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getWithdrawals');
    },
    patchWithdrawal: async ({ dispatch }, id) => {
      try {
        const { data } = await withdrawals.patch(id);
      } catch (error) {}
      dispatch('getWithdrawals');
    },
    getWithdrawalById: async ({ commit }, id) => {
      try {
        const { data } = await withdrawals.getById(id);
        commit('SET_WITHDRAWAL', data);
      } catch (error) {}
    },
    getWithdrawals: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await withdrawals.get(state.currentPage);
        commit('SET_WITHDRAWALS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
